import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';

import { ConfiguracaoCaixaApiService } from '../services/configuracao-caixa-api.service';
import { ContaCaixaConfiguracao } from '../models/conta-caixa-configuracao';


@Injectable()
export class ConfiguracaoCaixaResolver implements Resolve<ContaCaixaConfiguracao[]> {

  constructor(
    private configuracaoCaixaApiService: ConfiguracaoCaixaApiService,
  ) { }

  resolve(): Observable<ContaCaixaConfiguracao[]> {
    return this.configuracaoCaixaApiService.getContasCaixa();
  }
}
